import { useRef, useState, useEffect } from 'react';
import queryString from 'query-string';
import { Container, Stack } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

import _ from 'lodash';
import Page from 'components/Page';
import { PATH_ANALYTICS, PATH_SPEMPLOYEE, PATH_STORE } from 'routes/paths';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import useAuth from 'hooks/useAuth';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  createSpEmployeeApi,
  getEmployeeByEmployeeIdApi,
  updateSPEmployeeApi,
  uploadEmployeeProfileImageApi
} from 'redux/spEmployee/spEmployeeApi';
import { spEmployeeActions } from 'redux/spEmployee/spEmployeeSlice';
import PermissionGuard from 'guards/PermissionGuard';
import EmployeeForm from './components/EmployeeForm';

export default function CreateOrUpdateEmployee(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationQuery = window.location.search;
  const queryValues = queryString.parse(locationQuery);

  const [isLoading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const isEdit = location?.pathname?.includes('edit');
  const { spEmployeeDetail = {} } = useSelector(({ spEmployeeReducer }) => spEmployeeReducer);
  const { user = {} } = useAuth();
  const [docs, setDocs] = useState({});
  const [employeeIdError, setEmployeeIdError] = useState(false);

  useEffect(() => {
    const params = {};
    params.employeeId = queryValues?.employeeId;
    params.userName = user?.role === 'EMPLOYEE' ? user?.oemId : user?.userName;
    if (isEdit) {
      dispatch(getEmployeeByEmployeeIdApi(params));
    } else {
      dispatch(spEmployeeActions.resetEmployeeForm());
    }
  }, []);

  console.log(spEmployeeDetail, 'wl;krw');

  const formRef = useRef();

  const onBtFormSubmit = async () => {
    await formRef?.current?.submitForm();
    const formValidationRes = await formRef?.current?.validateForm();
    if (_.isEmpty(formValidationRes)) {
      const values = formRef?.current?.values;
      const reqBody = { ...spEmployeeDetail };
      console.log(reqBody, 'lwfeek');
      reqBody.nameSalutation = values.nameSalutation;
      reqBody.name = values.name;
      reqBody.designation = values.designation;
      reqBody.employeeId = values.employeeId;
      reqBody.email = values.email;
      reqBody.address = values.address;
      reqBody.dateOfBirth = values.dateOfBirth ? new Date(values.dateOfBirth).getDate() : null;
      reqBody.phoneNumber = { primary: values.phoneNumber, secondary: values.secondaryPhoneNumber };
      reqBody.emergencyDetails = {
        primary: {
          name: values.emergencyDetailsPrimaryName,
          phoneNumber: values.emergencyDetailsPrimaryPhoneNumber
        },
        secondary: {
          name: values.emergencyDetailsSecondaryName,
          phoneNumber: values.emergencyDetailsSecondaryPhoneNumber
        }
      };
      reqBody.userName = user?.role === 'EMPLOYEE' ? user?.oemId : user?.userName;

      console.log(reqBody, 'fdlslk');
      setLoading(true);

      try {
        let createEmployeeResponse = await dispatch(
          isEdit ? updateSPEmployeeApi(reqBody) : createSpEmployeeApi(reqBody)
        );
        createEmployeeResponse = unwrapResult(createEmployeeResponse);
        console.log(createEmployeeResponse, 'dfwle');
        if (createEmployeeResponse?.isPresent) {
          setEmployeeIdError(true);
          return;
        }
        if (!_.isEmpty(docs)) {
          const formData = new FormData();
          formData.append('employeeId', createEmployeeResponse?._id);
          const isFileToUpload = _.some(docs, (value, key) => value?.uploadFile);
          if (isFileToUpload) {
            _.map(docs, (value, key) => value?.uploadFile && formData.append('file', value?.uploadFile));
            const fileUploadRes = await dispatch(uploadEmployeeProfileImageApi(formData));
            unwrapResult(fileUploadRes);
          }
        }
        setLoading(false);
        enqueueSnackbar(`User ${isEdit ? 'Updated' : 'Created'} Successfully`, { variant: 'success' });
        navigate(user?.role === 'EMPLOYEE' ? PATH_ANALYTICS.root : PATH_SPEMPLOYEE.root, { replace: true });
      } catch (err) {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {((!isEdit && user?.accessList?.USER?.CREATE) || (isEdit && user?.accessList?.USER?.UPDATE)) && (
        <Page title="Create a new User | Serviceplug">
          <Container maxWidth="lg" sx={{ mt: '25px' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0}>
              <HeaderBreadcrumbs
                heading={!isEdit ? 'Create a new employee' : 'Edit Employee'}
                links={[
                  { name: 'Employee', href: 'PATH_SPEMPLOYEE.root' },
                  {
                    name: !isEdit ? 'Create' : 'Edit',
                    href: PATH_SPEMPLOYEE.create
                  }
                ]}
              />
              <LoadingButton
                variant="contained"
                onClick={onBtFormSubmit}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                loading={isLoading}
              >
                {isEdit ? 'Update' : 'Save'}
              </LoadingButton>
            </Stack>
            <EmployeeForm
              formRef={formRef}
              docs={docs}
              setDocs={setDocs}
              isEdit={isEdit}
              employeeIdError={employeeIdError}
              setEmployeeIdError={setEmployeeIdError}
              setLoading={setLoading}
            />
          </Container>
        </Page>
      )}
      {((!isEdit && !user?.accessList?.USER?.CREATE) || (isEdit && !user?.accessList?.USER?.UPDATE)) && (
        <PermissionGuard />
      )}
    </>
  );
}
